fetch(window.districtDataUrl)
  .then((response) => response.json())
  .then((data) => {
    const citySelects = document.querySelectorAll(".city-select");

    citySelects.forEach((citySelect) => {
      const form = citySelect.closest("form");
      if (!form) return;

      const districtSelect = form.querySelector(".district-select");
      const subdistrictSelect = form.querySelector(".subdistrict-select");

      if (!districtSelect || !subdistrictSelect) return;

      if (citySelect.dataset.initialized === "true") return;
      citySelect.dataset.initialized = "true";

      // Reset selects
      citySelect.innerHTML = '<option value="">' + getPlaceholder('city') + '</option>';
      districtSelect.innerHTML = '<option value="">' + getPlaceholder('district') + '</option>';
      subdistrictSelect.innerHTML = '<option value="">' + getPlaceholder('sub_district') + '</option>';

      // Populate city options
      Object.keys(data).forEach((city) => {
        const option = document.createElement("option");
        option.value = city;
        if (city.includes('中國香港特別行政區')) {
          option.textContent = '(Hong Kong Special Administrative Region of China) ' + city;
        } else {
          option.textContent = '(Macau Special Administrative Region of China) ' + city;
        }
        citySelect.appendChild(option);
      });

      // ---- Prefill Logic ----
      const currentCityEl = form.querySelector(".current_city");
      const currentDistrictEl = form.querySelector(".current_district");
      const currentSubDistrictEl = form.querySelector(".current_sub_district");

      const currentCity = currentCityEl?.textContent?.trim();
      const currentDistrict = currentDistrictEl?.textContent?.trim();
      const currentSubDistrict = currentSubDistrictEl?.textContent?.trim();

      const shouldPrefill = currentCity && currentDistrict && currentSubDistrict;

      if (shouldPrefill && data[currentCity]) {
        // Set city
        citySelect.value = currentCity;

        // Populate districts
        Object.values(data[currentCity]).forEach((districtObj) => {
          const option = document.createElement("option");
          option.value = districtObj.name;
          option.textContent = districtObj.name;
          districtSelect.appendChild(option);
        });

        // Set district
        if (data[currentCity][currentDistrict]) {
          districtSelect.value = data[currentCity][currentDistrict].name;

          // Populate subdistricts
          data[currentCity][currentDistrict].sub_districts.forEach((sub) => {
            const option = document.createElement("option");
            option.value = sub;
            option.textContent = sub;
            subdistrictSelect.appendChild(option);
          });

          // Set sub-district
          subdistrictSelect.value = currentSubDistrict;
        }
      }

      // Handle city change
      citySelect.addEventListener("change", () => {
        const selectedCity = citySelect.value;

        districtSelect.innerHTML = '<option value="">' + getPlaceholder('district') + '</option>';
        subdistrictSelect.innerHTML = '<option value="">' + getPlaceholder('sub_district') + '</option>';

        if (!data[selectedCity]) return;

        Object.values(data[selectedCity]).forEach((districtObj) => {
          const option = document.createElement("option");
          option.value = districtObj.name;
          option.textContent = districtObj.name;
          districtSelect.appendChild(option);
        });
      });

      // Handle district change
      districtSelect.addEventListener("change", () => {
        const selectedCity = citySelect.value;
        const selectedDistrict = districtSelect.value;

        subdistrictSelect.innerHTML = '<option value="">' + getPlaceholder('sub_district') + '</option>';

        if (data[selectedCity] && data[selectedCity][selectedDistrict]) {
          data[selectedCity][selectedDistrict].sub_districts.forEach((sub) => {
            const option = document.createElement("option");
            option.value = sub;
            option.textContent = sub;
            subdistrictSelect.appendChild(option);
          });
        }
      });
    });
  })
  .catch((error) => {
    console.error("Error loading district data:", error);
  });

function getPlaceholder(type) {
  return window.themeTranslations?.[type] || "";
}
